const reg = /-([\da-z])/gi;
const eachCamelCase = function (all, found) {
    return found.toUpperCase();
};

export default function camelCase(str) {
    return str.replace(reg, eachCamelCase);
}
